const I18N = {
  en: {
    title: 'Sign in to SharkClean',
    subtitle: 'Link your SharkClean account to Alexa',
    subtitleGoogle: 'Link your SharkClean account to Google Home',
    instruction: 'Use your SharkClean account credentials. Do not use your Amazon account credentials.',
    instructionGoogle:
      'Use your SharkClean account credentials. Do not use your Google account credentials.',
    usernameLabel: 'Email or username',
    passwordLabel: 'Password',
    showPassword: 'Show Password',
    login: 'Sign In',
    processing: 'Processing...',
    loginFailedTitle: 'Login Failed',
    invalidCredentials: 'Your username or password is incorrect.',
    missingFields: 'Please enter both username and password.',
    invalidEmail: 'Please enter a valid email address.',
    usernameTrim: 'Remove leading or trailing spaces in the username.',
    passwordSpaces: 'Password has leading/trailing spaces. Please confirm and remove if unintended.',
    configError: 'Service configuration error. Please try again later.',
    otherMethods: 'Other sign-in methods',
  },
  de: {
    title: 'Bei SharkClean anmelden',
    subtitle: 'Verknupfen Sie Ihr SharkClean-Konto mit Alexa',
    subtitleGoogle: 'Verknupfen Sie Ihr SharkClean-Konto mit Google Home',
    instruction: 'Verwenden Sie Ihre SharkClean-Kontodaten, nicht Ihre Amazon-Kontodaten.',
    instructionGoogle:
      'Verwenden Sie Ihre SharkClean-Kontodaten, nicht Ihre Google-Kontodaten.',
    usernameLabel: 'E-Mail oder Benutzername',
    passwordLabel: 'Passwort',
    showPassword: 'Passwort anzeigen',
    login: 'Anmelden',
    processing: 'Wird verarbeitet...',
    loginFailedTitle: 'Anmeldung fehlgeschlagen',
    invalidCredentials: 'Ihr Benutzername oder Passwort ist nicht korrekt.',
    missingFields: 'Bitte geben Sie Benutzername und Passwort ein.',
    invalidEmail: 'Bitte geben Sie eine gultige E-Mail-Adresse ein.',
    usernameTrim: 'Entfernen Sie Leerzeichen am Anfang oder Ende des Benutzernamens.',
    passwordSpaces: 'Das Passwort enthalt Leerzeichen am Anfang/Ende. Bitte prufen und ggf. entfernen.',
    configError: 'Service configuration error. Please try again later.',
    otherMethods: 'Weitere Anmeldemethoden',
  },
  es: {
    title: 'Iniciar sesion en SharkClean',
    subtitle: 'Vincula tu cuenta de SharkClean con Alexa',
    subtitleGoogle: 'Vincula tu cuenta de SharkClean con Google Home',
    instruction: 'Usa tus credenciales de SharkClean. No uses tus credenciales de Amazon.',
    instructionGoogle: 'Usa tus credenciales de SharkClean. No uses tus credenciales de Google.',
    usernameLabel: 'Correo o usuario',
    passwordLabel: 'Contrasena',
    showPassword: 'Mostrar contrasena',
    login: 'Iniciar sesion',
    processing: 'Procesando...',
    loginFailedTitle: 'Error de inicio de sesion',
    invalidCredentials: 'Tu usuario o contrasena es incorrecto.',
    missingFields: 'Ingresa usuario y contrasena.',
    invalidEmail: 'Ingresa un correo electronico valido.',
    usernameTrim: 'Elimina espacios al inicio o final del usuario.',
    passwordSpaces: 'La contrasena tiene espacios al inicio/final. Verifica y elimina si no son intencionales.',
    configError: 'Service configuration error. Please try again later.',
    otherMethods: 'Otros metodos de inicio',
  },
  fr: {
    title: 'Connexion a SharkClean',
    subtitle: 'Liez votre compte SharkClean a Alexa',
    subtitleGoogle: 'Liez votre compte SharkClean a Google Home',
    instruction: 'Utilisez vos identifiants SharkClean. N utilisez pas vos identifiants Amazon.',
    instructionGoogle:
      'Utilisez vos identifiants SharkClean. N utilisez pas vos identifiants Google.',
    usernameLabel: 'E-mail ou nom d utilisateur',
    passwordLabel: 'Mot de passe',
    showPassword: 'Afficher le mot de passe',
    login: 'Se connecter',
    processing: 'Traitement...',
    loginFailedTitle: 'Echec de connexion',
    invalidCredentials: 'Votre nom d utilisateur ou mot de passe est incorrect.',
    missingFields: 'Veuillez saisir votre nom d utilisateur et mot de passe.',
    invalidEmail: 'Veuillez saisir une adresse e-mail valide.',
    usernameTrim: 'Supprimez les espaces au debut ou a la fin du nom d utilisateur.',
    passwordSpaces: 'Le mot de passe contient des espaces au debut/fin. Verifiez et supprimez si non intentionnel.',
    configError: 'Service configuration error. Please try again later.',
    otherMethods: 'Autres methodes de connexion',
  },
  it: {
    title: 'Accedi a SharkClean',
    subtitle: 'Collega il tuo account SharkClean ad Alexa',
    subtitleGoogle: 'Collega il tuo account SharkClean a Google Home',
    instruction: 'Usa le credenziali del tuo account SharkClean. Non usare le credenziali Amazon.',
    instructionGoogle:
      'Usa le credenziali del tuo account SharkClean. Non usare le credenziali Google.',
    usernameLabel: 'Email o nome utente',
    passwordLabel: 'Password',
    showPassword: 'Mostra password',
    login: 'Accedi',
    processing: 'Elaborazione...',
    loginFailedTitle: 'Accesso non riuscito',
    invalidCredentials: 'Nome utente o password non corretti.',
    missingFields: 'Inserisci nome utente e password.',
    invalidEmail: 'Inserisci un indirizzo email valido.',
    usernameTrim: 'Rimuovi gli spazi iniziali o finali dal nome utente.',
    passwordSpaces: 'La password contiene spazi iniziali/finali. Verifica e rimuovili se non intenzionali.',
    configError: 'Service configuration error. Please try again later.',
    otherMethods: 'Altri metodi di accesso',
  },
};

const SUPPORTED_LOCALES = new Set([
  'en-us', 'en-au', 'en-ca', 'en-in', 'en-gb',
  'de-de',
  'es-es', 'es-mx', 'es-us',
  'fr-fr', 'fr-ca',
  'it-it',
]);

const DEFAULT_LOCALE = 'en-us';

const normalizeLocale = (value) => (value || '').toLowerCase().replace('_', '-');

export const getLocalizedText = (
  search = window.location.search,
  nav = navigator,
  linkingProvider = 'alexa'
) => {
  const queryParams = new URLSearchParams(search);
  const langFromQuery = normalizeLocale(queryParams.get('lang'));
  const browserLang = normalizeLocale(
    (nav.languages && nav.languages[0]) || nav.language || nav.browserLanguage || DEFAULT_LOCALE
  );
  const requestedLocale = langFromQuery || browserLang || DEFAULT_LOCALE;
  const resolvedLocale = SUPPORTED_LOCALES.has(requestedLocale) ? requestedLocale : DEFAULT_LOCALE;
  const languageCode = resolvedLocale.split('-')[0];

  const base = I18N[languageCode] || I18N.en;
  const fallbackEn = I18N.en;

  if (linkingProvider === 'google') {
    return {
      ...base,
      subtitle: base.subtitleGoogle || fallbackEn.subtitleGoogle,
      instruction: base.instructionGoogle || fallbackEn.instructionGoogle,
    };
  }

  return base;
};
